import React from "react";

const HistoryLeaderboardModal = ({
  isOpen,
  onClose,
  title = "Attempt History",
  loading = false,
  history = [],
  liveAvatars = {},
}) => {
  if (!isOpen) return null;

  return (
    <div
      className="fixed inset-0 z-[120] flex items-center justify-center bg-slate-900/50 p-4 backdrop-blur-sm animate-in fade-in duration-200"
      onClick={onClose}
    >
      <div
        className="bg-white rounded-3xl shadow-2xl w-full max-w-lg max-h-[85vh] flex flex-col overflow-hidden animate-in zoom-in-95 duration-200 border border-gray-100"
        onClick={(e) => e.stopPropagation()}
      >
        <div className="px-6 py-5 border-b border-gray-100 flex items-center justify-between">
          <div>
            <h3 className="text-lg font-bold text-gray-900">Attempt History</h3>
            <p className="text-xs text-gray-500 mt-0.5 truncate max-w-xs">{title}</p>
          </div>
          <button
            type="button"
            onClick={onClose}
            className="w-8 h-8 rounded-full hover:bg-gray-100 text-gray-400 hover:text-gray-700 transition flex items-center justify-center"
          >
            <i className="fa-solid fa-xmark"></i>
          </button>
        </div>

        <div className="flex-1 overflow-y-auto p-6">
          {loading ? (
            <div className="flex flex-col items-center justify-center py-12 text-gray-400">
              <i className="fa-solid fa-circle-notch fa-spin text-3xl mb-3 text-blue-600"></i>
              <p className="text-sm font-semibold text-gray-600">Loading attempt history...</p>
            </div>
          ) : history.length === 0 ? (
            <div className="flex flex-col items-center justify-center py-12 text-gray-400">
              <i className="fa-solid fa-chart-simple text-4xl mb-3 text-gray-300"></i>
              <p className="font-bold text-gray-700">No attempts yet</p>
              <p className="text-xs text-gray-400 mt-1">
                Take the quiz on this reviewer to see scores here.
              </p>
            </div>
          ) : (
            <div className="space-y-3">
              {history.map((h, i) => {
                const pct = h.percentage ?? 0;
                const color =
                  pct >= 80
                    ? "text-emerald-700 bg-emerald-50 border-emerald-200"
                    : pct >= 50
                    ? "text-amber-700 bg-amber-50 border-amber-200"
                    : "text-rose-700 bg-rose-50 border-rose-200";
                const date = new Date(h.createdAt).toLocaleString([], {
                  month: "short",
                  day: "numeric",
                  year: "numeric",
                  hour: "2-digit",
                  minute: "2-digit",
                });
                const mins = h.timeSpentSeconds
                  ? `${Math.floor(h.timeSpentSeconds / 60)}m ${h.timeSpentSeconds % 60}s`
                  : "—";
                const fullName =
                  `${h.user?.firstName || ""} ${h.user?.lastName || ""}`.trim() || "Member";
                const initials =
                  (h.user?.firstName?.[0] || "") + (h.user?.lastName?.[0] || "");

                return (
                  <div
                    key={h._id}
                    className="flex items-center gap-3.5 p-3.5 rounded-2xl border border-gray-100 bg-white shadow-xs"
                  >
                    <span
                      className={`w-6 text-center text-xs font-bold ${
                        i === 0
                          ? "text-amber-500 font-extrabold"
                          : i === 1
                          ? "text-slate-400 font-bold"
                          : i === 2
                          ? "text-amber-700 font-bold"
                          : "text-gray-400"
                      }`}
                    >
                      {i === 0 ? "🥇" : i === 1 ? "🥈" : i === 2 ? "🥉" : `#${i + 1}`}
                    </span>
                    {liveAvatars[String(h.user?._id)] || h.user?.avatar ? (
                      <img
                        src={liveAvatars[String(h.user?._id)] || h.user.avatar}
                        alt={fullName}
                        className="w-10 h-10 rounded-full object-cover border border-gray-200 shrink-0"
                      />
                    ) : (
                      <div className="w-10 h-10 rounded-full bg-blue-100 text-blue-700 flex items-center justify-center font-bold text-xs shrink-0">
                        {initials || "?"}
                      </div>
                    )}
                    <div className="flex-1 min-w-0">
                      <p className="text-sm font-bold text-gray-900 truncate">{fullName}</p>
                      <p className="text-xs text-gray-400">
                        {h.score}/{h.totalQuestions} correct • {h.mode} • {mins}
                      </p>
                      <p className="text-[10px] text-gray-400">{date}</p>
                    </div>
                    <span className={`text-xs font-bold px-2.5 py-1 rounded-full border ${color}`}>
                      {pct}%
                    </span>
                  </div>
                );
              })}
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default HistoryLeaderboardModal;
